module.exports = __webpack_public_path__ + "static/img/program_08.5bfaff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_08.jpg
// module id = Zdkm
// module chunks = 0